import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M2.197 12.803A7.474 7.474 0 0 0 7.5 15c1.732 0 3.46-.602 4.858-1.794l4.768 4.767.849-.848-4.768-4.768c2.513-2.947 2.383-7.376-.402-10.161A7.485 7.485 0 0 0 7.5 0a7.474 7.474 0 0 0-5.303 2.197 7.5 7.5 0 0 0 0 10.606zM1.2 7.5c0-1.683.656-3.265 1.845-4.455S5.817 1.2 7.5 1.2c1.683 0 3.265.655 4.455 1.845a6.308 6.308 0 0 1 0 8.91A6.258 6.258 0 0 1 7.5 13.8a6.258 6.258 0 0 1-4.455-1.845A6.258 6.258 0 0 1 1.2 7.5z" />
  </svg>
);

export default SvgComponent;
